<div class="padding">
    @if (order.orderTypeID === 'AssetMultiSearch') {
    <lib-static-notice
        [text]="'orders.multiJurisdictionAssetSearchesRetrieveOnly' | transloco"></lib-static-notice>
    }
    <form [formGroup]="searchForm">
        @if (order.orderTypeID === 'AssetMultiSearch') {
        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.serialNumber' | transloco }}</mat-label>
                    <input matInput [formControlName]="'serialNumber'" name="serial-number" [placeholder]="'common.labels.serialNumber' | transloco">
                </mat-form-field>
                <lib-error-bubble [control]="searchForm.get('serialNumber')!"
                    [message]="serialNumberError$"></lib-error-bubble>
            </div>
        </div>
        } @else if (order.orderTypeID === 'DebtorMultiSearch') {
        <div class="flex-container">
            <div class="flex-item form-field">
                <mat-radio-group formControlName="exactOnlyResults" name="exact-similar"
                    [attr.aria-label]="'orders.exactOrSimilarsRadioOption' | transloco">
                    <mat-radio-button class="radio-button" [value]="false">{{ 'orders.includeSimilars' | transloco }}</mat-radio-button>
                    <mat-radio-button class="radio-button" [value]="true">{{ 'orders.exactOnly' | transloco }}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="flex-container">
            <div class="flex-item form-field">
                <mat-radio-group [formControlName]="'partyTypeID'" name="party-type"
                    [attr.aria-label]="'orders.debtorIndividualOrBusinessRadioOption' | transloco">
                    <mat-radio-button class="radio-button" value="IndividualDebtor">{{ 'orders.individualDebtor' | transloco }}</mat-radio-button>
                    <mat-radio-button class="radio-button" value="BusinessDebtor">{{ 'orders.businessDebtor' | transloco }}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        @if (searchForm.get('partyTypeID')?.value === 'IndividualDebtor') {
        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
                    <input matInput [formControlName]="'firstName'" name="first-name" [placeholder]="'common.labels.firstName' | transloco">
                </mat-form-field>
                <lib-error-bubble [control]="searchForm.get('firstName')!"
                    [message]="firstNameError$"></lib-error-bubble>
            </div>
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
                    <input matInput [formControlName]="'middleName'" name="middle-name" [placeholder]="'common.labels.middleName' | transloco">
                </mat-form-field>
                <lib-error-bubble [control]="searchForm.get('middleName')!"
                    [message]="middleNameError$"></lib-error-bubble>
            </div>
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
                    <input matInput [formControlName]="'lastName'" name="last-name" [placeholder]="'common.labels.lastName' | transloco">
                </mat-form-field>
                <lib-error-bubble [control]="searchForm.get('lastName')!" [message]="lastNameError$"></lib-error-bubble>
            </div>
        </div>
        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="form-field flex-item" appearance="outline">
                    <mat-label>{{ 'orders.birthDate' | transloco }}</mat-label>
                    <input matInput [matDatepicker]="dateOfBirth" [formControlName]="'dateOfBirth'" name="date-of-birth"
                        [placeholder]="'common.labels.yyyyMmDd' | transloco">
                    <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfBirth></mat-datepicker>
                </mat-form-field>
                <lib-error-bubble [control]="searchForm.get('dateOfBirth')!"
                    [message]="dateOfBirthError$"></lib-error-bubble>
            </div>
        </div>
        }

        @if (searchForm.get('partyTypeID')?.value === 'BusinessDebtor') {
        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
                    <input matInput [formControlName]="'busName'" name="business-name" [placeholder]="'common.labels.businessName' | transloco">
                </mat-form-field>
                <lib-error-bubble [control]="searchForm.get('busName')!" [message]="busNameError$"></lib-error-bubble>
            </div>
        </div>
        }
        }
    </form>

    <lib-multi-jurisdiction-select [orderTypes]="orderTypes" [initialJurisdictions]="orderJurisdictions"
        (selectedJurisdictions)="onJurisdictionSelected($event)"></lib-multi-jurisdiction-select>
</div>